import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './redux/store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Loading from 'components/loading';
import App from './app';
import './assets/styles/fonts.css';
import './assets/styles/app.scss';
import 'react-day-picker/dist/style.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-international-phone/style.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 0, // Ma'lumotlar har doim yangi bo'lib turishi uchun
      cacheTime: 0, // Keshlashni o'chirish
      refetchOnMount: true, // Har doim mount qilganda qayta so'rov
      refetchOnReconnect: true, // Qayta ulanishda qayta so'rov
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={<Loading />} persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);
